import React from "react";
import Footer from "../components/layout/Footer";
import Header from "../components/layout/Header";

const plans = [
  {
    title: "Standard",
    price: "$199.00",
    features: [
      "Lorem Ipsum is simply dummy text ",
      "The printing and typesetting industry",
      "Lorem Ipsum is simply dummy text",
      "Lorem Ipsum is simply dummy text",
      "Lorem Ipsum is simply dummy text Questions",
    ],
  },
  {
    title: "Featured",
    price: "$249.00",
    features: [
      "Lorem Ipsum is simply dummy text",
      "Customizable Organization Profile",
      "Lorem Ipsum is simply dummy text",
      "Discounted Background Checks",
      "Lorem Ipsum is simply dummy text the Pricing Table",
      "Lorem Ipsum is simply dummy text",
      "Lorem Ipsum is simply",
    ],
    highlighted: true,
  },
  {
    title: "Premier",
    price: "$299.00",
    features: [
      "Lorem Ipsum is simply dummy text",
      "Customizable Organization Profile",
      "Lorem Ipsum is simply dummy text",
      "Discounted Background Checks",
      "Lorem Ipsum is simply dummy text the Pricing Table",
      "Lorem Ipsum is simply dummy text",
      "Lorem Ipsum is simply",
      "Lorem Ipsum dummy text",
      "Lorem Ipsum is simply dummy text",
    ],
  },
];

const Pricing = () => {
  return (
    <main className="min-h-screen bg-[#111318] text-slate-200">
      <Header />

      <section className="px-4 py-10 sm:px-6 sm:py-12 lg:px-8">
        <div className="mx-auto max-w-6xl">
          <div className="mb-10">
            <h1 className="text-center text-3xl font-bold tracking-[-0.02em] text-slate-50 sm:text-4xl">
              Pricing Plans
            </h1>
          </div>

          <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-3">
            {plans.map((plan, index) => (
              <div
                key={index}
                className={`rounded-3xl border p-6 shadow-[0_12px_30px_rgba(0,0,0,0.18)] transition duration-300 hover:-translate-y-0.5 hover:border-blue-400/60 ${
                  plan.highlighted
                    ? "border-blue-500/50 bg-[linear-gradient(180deg,rgba(30,58,138,0.16),rgba(15,23,42,0.94))]"
                    : "border-slate-700/70 bg-[linear-gradient(180deg,rgba(30,41,59,0.82),rgba(15,23,42,0.9))]"
                }`}
              >
                <h3 className="mb-2 text-lg font-semibold text-slate-100">{plan.title}</h3>
                <h2 className="mb-4 text-4xl font-bold tracking-[-0.03em] text-white">
                  {plan.price}
                </h2>

                <hr className="my-5 border-slate-700/60" />

                <p className="mb-3 text-sm font-semibold uppercase tracking-[0.14em] text-slate-300">
                  What&apos;s Included?
                </p>

                <ul className="space-y-3">
                  {plan.features.map((feature, i) => (
                    <li key={i} className="flex items-start gap-3 text-sm leading-6 text-slate-300">
                      <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-blue-600/80 text-[11px] font-semibold text-white">
                        ✓
                      </span>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
};

export default Pricing;
